import { useCallback, useState } from 'react';

// To throw errors from async function for ErrorBoundary to catch them
export const useAsyncError = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setError] = useState(null);

    return useCallback(
        (error: Error) => {
            setError(() => {
                throw error;
            });
        },
        [setError],
    );
};
